import $ from 'jquery';
import React from 'react';
import SessionManager from '../routes/SessionManager';
import moment from 'moment';
import { Table } from "antd";
import { DatePicker } from 'antd';
const { RangePicker } = DatePicker;


class PPEReportLibrary extends React.Component {
    constructor(props) {
        super();

        var sessionMgr = new SessionManager();
        this.user = sessionMgr.readCookie('user');
        this.timezone = this.user.site_selected.site_iana_timezone;
        var start_date = moment().add(-6, 'days');
        var end_date = moment();

        this.state = {
            start_date: start_date.format('YYYY-MM-DD'),
            end_date: end_date.format('YYYY-MM-DD'),
            defaultDates: [start_date, end_date],
            ppe_reports: [],
            loading: true
        }
    }

    componentDidMount() {
        this.fetchPPEReports();
    }

    fetchPPEReports() {
        let _this = this;
        var data = {
            site_id: _this.user.site_selected.site_id,
            user_login: _this.user.user_login,
            user_token: _this.user.user_token,
            operation: 'ppe-report',
            timezone: this.timezone,
            created_by: _this.user.user_login,
            start_date: this.state.start_date,
            end_date: this.state.end_date
        }

        $.ajax({
            url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/ppe-report',
            type: 'POST',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            data: JSON.stringify(data)
        }).then(
            (res) => {
                if (res.status && res.status.code === 200) {
                    this.setState({ ppe_reports: res.data, loading: false });
                }
            },
            (error) => {
                this.setState({ ppe_reports: [], loading: false });
            }
        );
    }

    disabledDate(current) {
        // Can not select days after today
        return current && current > moment(new Date(), 'YYYY-MM-DD');
    }

    handleInput = (obj) => {
        this.setState({ start_date: obj ? obj[0].format('YYYY-MM-DD') : '', end_date: obj ? obj[1].format('YYYY-MM-DD') : '' })
    }

    render() {
        let columns = [
            {
                title: "File Name",
                dataIndex: "report_name",
                key: "report_name",
                render: (report_name, record) => <a href={record.report_pdf} rel="noopener noreferrer" target="_blank">{report_name}</a>
            }, {
                title: "Report Date",
                dataIndex: "report_timestamp",
                key: "report_timestamp",
                render: (text, record) => moment.tz(text * 1000, this.user.site_selected.site_iana_timezone).format('YYYY-MM-DD')
            }, {
                title: "Comments",
                dataIndex: "comments",
                key: "comments"
            }, {
                title: "Created By",
                dataIndex: "created_by",
                key: "created_by"
            }, {
                title: "Created Date",
                dataIndex: "created_date",
                key: "created_date"
            }];
        return (
            <React.Fragment>
                <div className="page-container">
                    <div className="row mb-1">
                        <div className="col-md-12 text-primary">Select Date range, Report Type(s) to retrieve reports</div>
                    </div>
                    <div className="row mb-2">
                        <div className="col-md-12">
                            <RangePicker disabledDate={this.disabledDate} defaultValue={this.state.defaultDates} onChange={(obj) => this.handleInput(obj)} />
                            <button disabled={this.state.start_date === '' || this.state.end_date === ''} id="submitBtn" className="btn btn-sm btn-primary ml-1" onClick={() => this.fetchPPEReports()}>Submit</button>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <Table dataSource={this.state.ppe_reports} columns={columns} loading={this.state.loading} />
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default PPEReportLibrary;